/*! @license Firebase v3.7.6
Build: rev-d1c8cec
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PromiseImpl = Promise || require('promise-polyfill');
var local = exports.local = {
    Promise: PromiseImpl,
    GoogPromise: PromiseImpl
};



//////////////////
// WEBPACK FOOTER
// ./~/firebase/app/shared_promise.js
// module id = 174
// module chunks = 2